import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MDBBootstrapModulesPro } from "ng-uikit-pro-standard";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { NgxPaginationModule } from "ngx-pagination";

import { AppRoutingModule } from "../core/app-routing.module";
import { FooterComponent } from "./components/footer/footer.component";
import { MenuComponent } from "./components/menu/menu.component";
import { HomeComponent } from "./pages/home/home.component";
import { ExcelService } from "./services/excel.service";

export const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [FooterComponent, HomeComponent, MenuComponent],
  exports: [
    MDBBootstrapModulesPro,
    NgxPaginationModule,
    NgxMaskModule,
    MenuComponent,
    FooterComponent,
  ],
  imports: [
    NgxPaginationModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    NgxMaskModule.forRoot(maskConfig),
    MDBBootstrapModulesPro.forRoot(),
  ],
  providers: [ExcelService],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SharedModule {}
